<div class="input-section">
	<div class="title">
		{{ insuranceType }}
		<button mat-icon-button (click)="deleteInsurance()" *ngIf="canDelete">
			<mat-icon>delete</mat-icon>
		</button>
	</div>
	<div class="fields">
		<div class="row">
			<mat-form-field>
				<mat-label class="label">Insurance provider</mat-label>
				<input matInput required [(ngModel)]="insurance.provider">
			</mat-form-field>
			<mat-form-field>
				<mat-label class="label">EHR equivalent</mat-label>
				<mat-select [(ngModel)]="insurance.ehrEquivalent">
					<mat-option value="982">United Healthcare [982]</mat-option>
					<mat-option value="981">United Healthcare [981]</mat-option>
					<mat-option value="980">United Healthcare [980]</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="row">
			<mat-form-field>
				<mat-label class="label">Member ID</mat-label>
				<input matInput [(ngModel)]="insurance.patientMrn">
			</mat-form-field>
			<mat-form-field>
				<mat-label class="label">Primary holder</mat-label>
				<mat-select [(ngModel)]="insurance.primaryHolder">
					<mat-option value="SELF">Self</mat-option>
					<mat-option value="OTHER">Other</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="row">
			<mat-form-field *ngIf="insurance.primaryHolder == 'OTHER'">
				<mat-label class="label">Name of primary holder</mat-label>
				<input matInput [(ngModel)]="insurance.primaryHolderName">
			</mat-form-field>

			<mat-form-field *ngIf="insurance.primaryHolder == 'OTHER'">
				<mat-label class="label">Relationship to primary holder</mat-label>
				<mat-select [(ngModel)]="insurance.relationship">
					<mat-option value="SPOUSE">Spouse</mat-option>
					<mat-option value="CHILD">Child</mat-option>
					<mat-option value="OTHER">Other</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="row">
			<app-image-upload [label]="'Front of Card'" [imageSrc]="imageSrcFront" [target]="insurance" [field]="SurveyQuestions.SrcFront"></app-image-upload>
			<app-image-upload [label]="'Back of Card'" [imageSrc]="imageSrcBack"  [target]="insurance" [field]="SurveyQuestions.SrcBack"></app-image-upload>
		</div>
	</div>
</div>
